<script lang="ts">
  // Label + control + hint/error. `for` connects the label to the control's id.
  //   <Field label="Naam" for="name" error={errors.name}><Input id="name" bind:value={name} /></Field>
  import type { Snippet } from 'svelte';
  import '../messages/ui';
  import { t } from '../i18n.svelte';
  interface Props {
    label?: string;
    hint?: string;
    error?: string | null;
    optional?: boolean;
    optionalLabel?: string;
    for?: string;
    class?: string;
    aside?: Snippet;
    children: Snippet;
  }
  let { label, hint, error, optional = false, optionalLabel, for: htmlFor, class: cls = '', aside, children }: Props = $props();
</script>

<div class="field {cls}">
  {#if label}
    <div class="label-row">
      <label class="field-label" for={htmlFor}>
        {label}
        {#if optional}<span class="optional">({optionalLabel ?? t('ui.optional')})</span>{/if}
      </label>
      {#if aside}{@render aside()}{/if}
    </div>
  {/if}
  {@render children()}
  {#if error}
    <span class="field-error" role="alert">{error}</span>
  {:else if hint}
    <span class="field-hint">{hint}</span>
  {/if}
</div>

<style>
  .label-row { display: flex; align-items: center; justify-content: space-between; gap: var(--space-2); }
</style>
